const DURATION = 1000;

export default class AnimationProgress {
  /* eslint-disable lines-between-class-members */
  timestamp: number | null;
  duration: number;
  progress: number;
  delta: number;
  isLoop: boolean;
  /* eslint-enable lines-between-class-members */

  constructor(param: { duration?: number; isLoop?: boolean } = {}) {
    this.timestamp = null;
    this.duration = param.duration || DURATION;
    this.progress = 0;
    this.delta = 0;
    this.isLoop = !!param.isLoop;

    this.reset();
  }

  reset(): void {
    this.timestamp = null;
  }

  start(now: number): void {
    this.timestamp = now;
  }

  tick(now: number): number {
    if (this.timestamp) {
      this.delta = now - this.timestamp;
      this.progress = Math.min(this.delta / this.duration, 1);

      if (this.progress >= 1 && this.isLoop) {
        this.start(now);
      }
      return this.progress;
    }
    return 0;
  }
}
